<template>
  <div class="row">
    <Header
      :totalRows="totalRows"
      :AvailableLengths="AvailableLengths"
      :unAvailableLengths="unAvailableLengths"
      :fields="fields"
      :selected_view="selected_view"
      @selectField="selectField"
      @download="downloadVehicles"
      @resetFieldSelection="resetFieldSelection"
      @quickSearch="quickSearch"
      @selectView="selectView"
      @groupByKey="groupByKey"
      @showDownloadFilters="showDownloadFiltersMenu"
    />
    <VehiclesTable
      ref="VehiclesTable"
      @getAvailableLengths="getAvailableLengthsData"
      @resetQuickSearchPayload="reset"
      :fields="fields"
      :selected_view="selected_view"
      :showDownloadFilters="showDownloadFilters"
      @resetSearch="showDownloadFiltersReset"
    />
  </div>
</template>

<script>
import Header from './header.vue'
import VehiclesTable from './vehiclesTable.vue'
import { nanoid } from 'nanoid'
export default {
  components: {
    Header,
    VehiclesTable,
  },
  data() {
    return {
      AvailableLengths: null,
      unAvailableLengths: null,
      totalRows: null,
      search_term: null,
      selected_view: this.$route?.query?.view || 'table',
      showDownloadFilters: false,
      fields: [
        // {
        //   key: "tgaNumber",
        //   label: this.$t("tga-number"),
        //   sortable: true,
        //   class: "align-middle",
        //   thStyle: {
        //     backgroundPosition: "right -0.175rem center !important",
        //     paddingRight: "15px !important",
        //   },
        // },
        {
          selected: true,
          key: 'operationalID',
          label: this.$t('operational-id'),
          class: 'align-middle',
        },
        {
          selected: true,
          key: 'branch',
          label: this.$t('branch'),
          sortable: true,
          class: 'align-middle',
        },
        {
          selected: true,
          key: 'brand',
          label: this.$t('brand'),
          sortable: true,
          class: 'align-middle',
          thStyle: {
            backgroundPosition: 'right -0.1rem center !important',
            paddingRight: '15px !important',
          },
        },
        {
          selected: true,
          key: 'model',
          label: this.$t('model'),
          sortable: false,
          class: 'align-middle',
        },
        {
          selected: true,
          key: 'makeYear',
          label: this.$t('year-of-making'),
          sortable: true,
          class: 'px-1 align-middle',
          thStyle: {
            backgroundPosition: 'right -0.05rem center !important',
            paddingRight: '15px !important',
          },
        },
        {
          selected: true,
          key: 'chassisNumber',
          label: this.$t('chassis-number'),
          class: 'align-middle',
          sortable: false,
        },
        {
          selected: true,
          key: 'plateNumber',
          label: this.$t('plate-number'),
          class: 'align-middle',
        },
        {
          selected: true,
          key: 'serviceType',
          label: this.$t('service-type'),
          class: 'align-middle',
          sortable: false,
        },
        {
          selected: true,
          key: 'serialNumber',
          label: this.$t('serial-number'),
          class: 'align-middle',
          sortable: false,
        },
        // {
        //   key: "category",
        //   label: this.$t("vehicle-category"),
        //   sortable: false,
        //   class: "align-middle",
        // },
        {
          key: 'currentGarage',
          label: this.$t('garage'),
          sortable: true,
          selected: true,
          class: 'align-middle',
          thStyle: {
            backgroundPosition: 'right -0.175rem center !important',
            paddingRight: '15px !important',
          },
        },
        {
          selected: true,
          key: 'active',
          label: this.$t('status'),
          sortable: false,
          class: 'align-middle',
        },
        {
          selected: true,
          key: 'driver',
          label: this.$t('driver'),
          sortable: false,
          class: 'align-middle',
        },
        {
          selected: true,
          key: 'action',
          label: this.$t('action'),
          sortable: false,
          class: 'align-middle',
        },
      ],
    }
  },
  methods: {
    setValue(val, field) {
      this[field] = val
      this.$refs['VehiclesTable'].searchPayload.operationalID = val
    },
    search() {
      this.$refs['VehiclesTable'].filterBySideBar()
    },
    downloadVehicles() {
      this.$refs.VehiclesTable.downloadDirect()
    },
    downloadVehicles() {
      this.$refs.VehiclesTable.downloadDirect()
    },
      downloadVehicles() {
    this.$refs.VehiclesTable.downloadDirect();
  },
    reset() {
      this.search_term = null
    },
    getAvailableLengthsData(availableLengths, unAvailableLengths, totalRows) {
      this.AvailableLengths = availableLengths
      this.unAvailableLengths = unAvailableLengths
      this.totalRows = totalRows
    },
    selectField(option) {
      if (
        (this.fields.filter((each) => each.selected).length > 1 && option.selected) ||
        !option.selected
      )
        this.fields = this.fields?.map((each) => {
          if (each.key === option.key) each.selected = !each.selected
          return each
        })
    },
    resetFieldSelection() {
      this.fields = this.fields?.map((each) => {
        each.selected = true
        return each
      })
    },
    selectView(view) {
      this.selected_view = view
      this.$router.replace({ query: { view: view } }).catch(() => {})
    },
    quickSearch(key, value) {
      this.$refs['VehiclesTable'].quickSearch(key, value)
    },
    groupByKey(key) {
      this.$refs['VehiclesTable'].groupByKey(key)
    },
    showDownloadFiltersMenu() {
      this.showDownloadFilters = nanoid()
    },
    showDownloadFiltersReset() {
      this.showDownloadFilters = false
    },
  },
}
</script>
